import { useEffect } from 'react';

import toast from 'react-hot-toast';

import { useAuthStore } from '../stores/auth';

export function useErrorToast(error?: string) {
  const storedToken = useAuthStore((store) => store.storedToken);

  useEffect(() => {
    if (error) {
      if (!storedToken || error.includes('Forbidden')) toast.error('Wallet not connected or verifed!');
      else toast.error(error);
    }
  }, [error]);

  return null;
}
